module.exports = "/images/shinta.jpg?6b3b231075f02da779036d0431ce94a6";